import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { ActivityEventResponseDto } from '@domain/activity-event/dtos/activity-event.response.dto';
import { ListActivityEventRequestDto } from '@domain/activity-event/dtos/list-activity-event.request.dto';

@Injectable({
  providedIn: 'root',
})
export class ActivityEventService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('activity/event');
  }

  show(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/show/${refId}`;
    return this.http.get<ApiResponse<ActivityEventResponseDto>>(queryUrl, {});
  }

  list(request: ListActivityEventRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<ActivityEventResponseDto>>
    >(queryUrl, { params: { ...request } });
  }
}
